import { render, staticRenderFns } from "./LicenceForm.vue?vue&type=template&id=b65662f0"
import script from "./LicenceForm.vue?vue&type=script&lang=ts"
export * from "./LicenceForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports